import { Component, OnInit, } from '@angular/core';

import { RouterModule } from '@angular/router';
import { ConfirmDialogComponent } from '../../confirm-dialog/confirm-dialog.component';
import { PubService } from '../../../services/pub.service';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';
import { ToastService } from '../../../services/toast.service';

@Component({
  selector: 'app-pub-view-or-edit',
  imports: [RouterModule, ConfirmDialogComponent],
  templateUrl: './view-or-edit.component.html',
  styleUrl: './view-or-edit.component.css'
})
export class PubViewOrEditComponent implements OnInit {

  listings: any[] = [];
  loading = false;
  error = '';

  showDialog = false;
  selectedItem: any = null;
  busy = false;
  confirmError: string | null = null;

  isAdmin = false;
  filterMode: 'all' | 'mine' = 'all';

  constructor(private pubService: PubService, private routerService: Router, private toast: ToastService) { }

  ngOnInit(): void {
    this.isAdmin = window.location.hostname.startsWith('admin.');
    this.fetchListings();
  }

  onFilterChange(mode: 'all' | 'mine') {
    this.filterMode = mode;
    this.fetchListings();
  }

  async fetchListings() {
    this.loading = true;
    try {
      let params: any = {};
      // For Admin: Support filtering by "Admin" created items
      if (this.isAdmin && this.filterMode === 'mine') {
        params.createdBy = 'Admin';
      } else if (!this.isAdmin) {
        // Regular User: Only see MY listings
        params.createdBy = 'me';
      }

      const result = await firstValueFrom(this.pubService.list(params));
      this.listings = result.records || [];
    } catch (error) {
      console.error('Error loading listings:', error);
    } finally {
      this.loading = false;
    }
  }
  listingUrl(id: string): string {
    const tree = this.routerService.createUrlTree(['/pubs/view', id]);
    return this.routerService.serializeUrl(tree);
  }

  editListing(listing: any) {
    console.log('Edit listing:', listing);
    // Implement navigation to edit page or open a modal for editing
    this.routerService.navigate(['/pubs', listing.id]);
  }

  openDialog(item: any) {
    this.selectedItem = item;
    this.showDialog = true;
  }

  handleCancel() {
    this.showDialog = false;
    this.busy = false;
    this.confirmError = null;
  }

  handleConfirm() {
    if (!this.selectedItem) return;

    this.busy = true;
    this.confirmError = null;

    this.pubService.delete(this.selectedItem.id).subscribe({
      next: () => {
        this.listings = this.listings.filter(l => l.id !== this.selectedItem.id);

        this.showDialog = false;
        this.busy = false;
        this.toast.success('Pub deleted successfully');
        this.selectedItem = null;
      },
      error: (err) => {
        console.error('Error deleting pub:', err);
        this.confirmError = "Failed to delete pub. Try again.";
        this.busy = false;
      }
    });
  }
}
